module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-Black.fed924e.eot";